import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Icon } from "../index";
import styles from "./TabButton.module.css";

const TabButton = ({
  icon,
  size = "large",
  title,
  subtitle,
  text,
  chip,
  children,
  isSelected,
  onClick,
  disabled = false,
  grid,
  center = true,
  ...props
}) => {
  const hasTextBox = typeof text === "string";

  return (
    <Grid item xs={grid || 12} sm={grid || 6}>
      <Box
        className={`${styles.optionCard} ${disabled ? styles.disabled : isSelected ? styles.selectedOption : ""} ${styles[size]}`}
        sx={{ alignItems: center ? "center" : "flex-start" }}
        onClick={disabled ? undefined : onClick}
        role={onClick && !disabled ? "button" : undefined}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={(e) => {
          if (disabled || !onClick) return;
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick(e);
          }
        }}
        {...props}
      >
        {icon && (
          <Icon
            icon={icon}
            size={size}
            color="white"
            square
            className={styles.optionIcon}
          />
        )}
        <Box className={styles.column}>
          <Grid className={hasTextBox ? styles.row : styles.column}>
            <Typography className={styles.title}>{title}</Typography>
            <Box className={styles.subRow}>
              {subtitle && (
                <Typography className={styles.subtitle}>{subtitle}</Typography>
              )}
              {chip && <div className={styles.chip}>{chip}</div>}
            </Box>
          </Grid>
          {text && <Typography className={styles.text}>{text}</Typography>}
          {children}
        </Box>
      </Box>
    </Grid>
  );
};

export default TabButton;
